import React from "react";
import {CSSObject, styled} from "@core-ui/react-stitch";

const centerSVGCSS: CSSObject = {
  width: "75%",
  height: "75%",
  top: "50%",
  left: "50%",
  margin: 0,
  transform: "translate(-50%,-50%)",
  pointerEvents: "none",
};

const StyledSVG = styled.svg({
  zIndex: 2,
  position: "absolute",
  ...centerSVGCSS,
});

// Positions out-of-stock indicator over the swatch
const StyledGroup = styled.g({transform: "translate(10%, 110%)"});

// Length and angle of out-of-stock indicator
const StyledRect = styled.rect({
  transform: "rotate(-45deg)",
  width: "calc(100% + 0.25rem)",
});

export const StockIndicator = (): JSX.Element => (
  <StyledSVG viewBox="0 0 37 23">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <StyledGroup fill="#000000" stroke="#FFFFFF">
        <StyledRect height="2" />
      </StyledGroup>
    </g>
  </StyledSVG>
);
